module.exports = __webpack_public_path__ + "img/2013-3.f0a4903c.jpg";